import { render } from "./DoctorDashboard.vue?vue&type=template&id=497e1312&scoped=true"
import script from "./DoctorDashboard.vue?vue&type=script&lang=js"
export * from "./DoctorDashboard.vue?vue&type=script&lang=js"

import "./DoctorDashboard.vue?vue&type=style&index=0&id=497e1312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497e1312"]])

export default __exports__